import React, { Suspense } from 'react';
import { ILiveblogCard } from '@sky-it-cmscomposer/liveblog-design-system';

import { validateModel } from '../../utils/props-validator';
import { IComponentModel, IGenericObject } from '../../typings/common-types';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const LiveblogCardWrapper = React.lazy(() => import('./liveblog-card'));

interface IDynamicLiveblogCardWrapper extends IComponentModel<ILiveblogCard | {}> {
    model?: ILiveblogCard | {};
    query?: unknown;
    config?: IGenericObject;
}

const DynamicLiveblogCard: React.FC<IDynamicLiveblogCardWrapper> = ({
    /* istanbul ignore next: default value on mandatory field */
    model = {},
    /* istanbul ignore next: default value */
    query = {},
    /* istanbul ignore next: default value */
    children = null,
    /* istanbul ignore next: default value */
    config = {},
}) => (
    <Suspense fallback={<HtmlWrapper html={children} />}>
        <LiveblogCardWrapper initialModel={validateModel(model) as ILiveblogCard} query={validateModel(query)} config={config} />
    </Suspense>
);

/**
 * NOTE: YOU HAVE TO specify default props to be derived from web-component attributes
 */
DynamicLiveblogCard.defaultProps = {
    children: null,
    model: {} as ILiveblogCard,
    query: {},
    config: {},
};

export default DynamicLiveblogCard;
